module.exports = __webpack_public_path__ + "img/UN_Women_Spurning08.d8ed8c51.gif";